import { computed, inject } from "vue";
import type {
  IObjectNotificationsProvider,
  IObjectNotificationsProviderMethods
} from "@/models/providers/objectNotifications";

/**
 * Composable to inject objectNotification provider data and methods.
 */
export function useObjectNotificationInjector() {
  const objectNotificationDataProvider = inject<
    () => IObjectNotificationsProvider
  >("objectNotificationProvider");
  const objectNotificationMethodsProvider =
    inject<IObjectNotificationsProviderMethods>(
      "objectNotificationProviderMethods"
    );

  if (!objectNotificationDataProvider || !objectNotificationMethodsProvider) {
    throw new Error("'objectNotificationProvider' was not provided");
  }

  const objectNotificationData = computed(() =>
    objectNotificationDataProvider()
  );

  return {
    objectNotificationData,
    objectNotificationMethods: objectNotificationMethodsProvider
  };
}
